import { render, staticRenderFns } from "./30carInc.vue?vue&type=template&id=0da37fa3&scoped=true&"
import script from "./30carInc.vue?vue&type=script&lang=js&"
export * from "./30carInc.vue?vue&type=script&lang=js&"
import style0 from "./30carInc.vue?vue&type=style&index=0&id=0da37fa3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da37fa3",
  null
  
)

export default component.exports